import { useState } from 'react';
import { useAppStore } from '@/store/AppStore';
import Badge, { statusTone } from '@/components/base/Badge';
import JobDetail from '@/components/feature/JobDetail';
import EmptyState from '@/components/base/EmptyState';
import type { Job } from '@/types';

export default function BugununIsleri() {
  const { jobs } = useAppStore();
  const [selected, setSelected] = useState<Job | null>(null);

  const todaysJobs = jobs
    .filter((j) => j.date === '26 Ağustos 2026')
    .sort((a, b) => a.time.localeCompare(b.time));

  return (
    <div className="mx-auto max-w-[1400px] space-y-6">
      <div>
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-accent-600">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
          Operasyon
        </div>
        <h1 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">Bugün Kime Gidiyoruz?</h1>
        <p className="mt-1 text-sm text-foreground-500">Bugünün kronolojik iş akışı.</p>
      </div>

      {todaysJobs.length === 0 ? (
        <div className="rounded-lg border border-background-200 bg-white">
          <EmptyState
            icon="ri-calendar-check-line"
            title="Bugün planlanmış iş bulunmuyor."
            description="Bugün için planlanan bir iş yok."
          />
        </div>
      ) : (
        <div className="space-y-3">
          {todaysJobs.map((job) => (
            <div key={job.id} className="rounded-lg border border-background-200 bg-white p-5">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
                <div className="flex w-16 shrink-0 flex-col items-center justify-center rounded-lg bg-primary-50 py-3">
                  <span className="font-heading text-xl font-bold text-primary-700">{job.time.slice(0, 5)}</span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-base font-bold uppercase text-foreground-950">{job.customerName}</span>
                    <Badge tone={statusTone(job.status)}>{job.status}</Badge>
                  </div>
                  <div className="mt-0.5 text-sm text-foreground-600">{job.service}</div>
                  <div className="mt-1 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1"><i className="ri-map-pin-line" /> {job.location}</span>
                    <span className="flex items-center gap-1"><i className="ri-group-line" /> {job.team}</span>
                  </div>
                </div>
                <div className="flex shrink-0 flex-wrap items-center gap-2">
                  <a
                    href={`tel:${job.phone.replace(/\s/g, '')}`}
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 py-2 text-xs font-semibold text-foreground-700 hover:bg-background-100"
                  >
                    <i className="ri-phone-line" /> Ara
                  </a>
                  <a
                    href={`https://wa.me/90${job.phone.replace(/\s/g, '').slice(1)}`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 py-2 text-xs font-semibold text-foreground-700 hover:bg-background-100"
                  >
                    <i className="ri-whatsapp-line" /> WhatsApp
                  </a>
                  <button
                    type="button"
                    onClick={() => setSelected(job)}
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2 text-xs font-semibold text-white hover:bg-primary-600"
                  >
                    <i className="ri-play-circle-line" /> İşi Aç
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {selected && <JobDetail job={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}